<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          所属机构
        </div>
        <el-select
          v-model="searchForm.agencyId"
          placeholder="请选择所属机构"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agencyList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
        <div class="label">
          课程状态
        </div>
        <el-select
          v-model="searchForm.isRefund"
          placeholder="请选择课程状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in registrationRefundStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          课程分类
        </div>
        <el-select
          v-model="searchForm.courseCategoryId"
          placeholder="请选择课程分类"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in courseCategoryList"
            :key="item.value"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
        <div class="label">
          课程方式
        </div>
        <el-select
          v-model="searchForm.courseType"
          placeholder="请选择课程方式"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in courseTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="r">
        <el-select
          v-model="studentSearchType"
          class="input-select"
          placeholder="请选择状态"
          filterable
          clearable
          @change="clearSearchValue"
        >
          <el-option
            v-for="item in studentSearchList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="searchForm[studentSearchType]"
          :placeholder="placeholder[studentSearchType]"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          @click="goCreatOrEdit"
        >
          新增报名
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="tableColumn"
      @changeBypagination="tableHandle"
      @sortChange="sortChange"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, {
  studentSearchList, registrationRefundStatusList, courseTypeList, payMethodList,
} from '@/config';

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'sonList',
      },
      studentSearchList, // 搜索字段
      registrationRefundStatusList,
      courseTypeList,
      courseCategoryList: [],
      agencyList: [],
      cascaderInfo: '', // 省市区
      tabelData: {},
      studentSearchType: 'realName',
      placeholder: {
        realName: '请输入学员姓名',
        mobilePhone: '请输入学员手机号',
        idCard: '请输入学员身份证',
      },
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        agencyId: '', // 所属机构id
        sortType: null,
        isRefund: '',
        courseCategoryId: '', // 课程分类
        courseType: '', // 课程方式
        mobilePhone: '',
        idCard: '',
        realName: '',
      },
      tableColumn: [
        {
          key: 'realName',
          label: '学员姓名',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'agencyName',
          label: '所属机构',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agentUserName',
          label: '对应代理商人员',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '学员电话',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseName',
          label: '购买课程',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'isAgent',
          label: '是否代理商人员',
          width: '80px',
          dataType: 'component',
          renderProps: { 1: '是', 0: '否', successKey: 1 },
          render: () => 'status',
        },
        {
          key: 'isAgency',
          label: '是否机构人员',
          width: '80px',
          dataType: 'component',
          renderProps: { 1: '是', 0: '否', successKey: 1 },
          render: () => 'status',
        },
        {
          key: 'isRefund',
          label: '课程状态',
          width: 'auto',
          dataType: 'component',
          renderProps: { [types.IS_NO_REFUND]: '已退款', [types.IS_REFUND]: '未退款', successKey: types.IS_REFUND },
          render: () => 'status',
        },
        {
          key: 'payMethod',
          label: '支付方式',
          width: 'auto',
          dataType: 'function',
          renderProps: '',
          render: (key) => payMethodList.filter((item) => item.value === key),
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
          sortable: 'custom',
        },
        {
          key: 'control',
          label: '操作',
          width: '70px',
          dataType: 'component',
          renderProps: [
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },

  mounted() {
    this.getList();
    this.selectList();
  },
  methods: {
    // 切换下拉 清除选项的值
    clearSearchValue() {
      this.searchForm.idCard = '';
      this.searchForm.mobilePhone = '';
      this.searchForm.realName = '';
    },
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.registration.getList(this.searchForm);
      const { pageNum, pageSize, total } = result;
      result.list.forEach((element) => {
        this.$set(element, 'isAgency', element.userAgencyId !== null ? 1 : 0);
        this.$set(element, 'isAgent', element.userAgentId !== null ? 1 : 0);
      });
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    async selectList() {
      const all = {
        id: '',
        value: '全部',
      };
      this.courseCategoryList = await axClient.registration.listCategoryByRegistration();
      this.agencyList = await axClient.registration.listNameByRegistration();
      this.courseCategoryList = [all, ...this.courseCategoryList];
      this.agencyList = [all, ...this.agencyList];
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'StudentDetails', params: { id: item.userId } });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.goDetails(item);
          break;
        default:
          break;
      }
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        courseCompleteTime: {
          ascending: 30,
          descending: 40,
        },
        courseExpireTime: {
          ascending: 10,
          descending: 20,
        },
        createTime: {
          ascending: 50,
          descending: 60,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // 跳转到新增/编辑
    goCreatOrEdit() {
      this.$router.push({ name: 'RegistrationCreate' });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
